import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { InteractionStatus } from "@azure/msal-browser";
import { LicenseManager } from "ag-grid-enterprise";
import { useSelector, useDispatch } from "react-redux";
import "ag-grid-enterprise";
import "@mobiscroll/react/dist/css/mobiscroll.min.css";

import Header from "../components/header";
import Aside from "../components/aside";
import AuthContext from "../auth/AuthContext";
import Toaster from "../components/Toaster";
import AppointmentOverlay from "../components/AppointmentOverlay/AppointmentOverlay";
import AppointmentOverlayBoundary from "../components/AppointmentOverlay/AppointmentOverlayBoundary";
import useLoggedInAccount from "../auth/LoggedInAccountInfo";
import { RootState } from "../store";
import { hideToast } from "../store/slices/toastSlice";
import { AG_GRID_LICENSE } from "../constants/AgGrid";
import { cacheAllLookups } from "../grid/renderers/LookupCellValueGetter";
import { cacheAllWorkflowStates } from "../grid/renderers/WorkflowStateCellValueGetter";
import { loadData } from "../components/UserName";

LicenseManager.setLicenseKey(AG_GRID_LICENSE);

const ProtectedLayout = () => {
  const { instance, inProgress, loggedInAccount } = useLoggedInAccount();
  const clientTenantId = process.env.REACT_APP_CLIENT_TENANT_ID;
  const dispatch = useDispatch();
  const { show, type, title, message, icon } = useSelector(
    (state: RootState) => state.toast
  );

  useEffect(() => {
    if (loggedInAccount) {
      const activeAccount = instance.getActiveAccount();
      if (!activeAccount || (activeAccount && activeAccount.tenantId !== clientTenantId)) {
        instance.setActiveAccount(loggedInAccount);
      }
    }
    const params = new URLSearchParams(document.location.search);
    const customerType = params.get("type");
    if (inProgress === InteractionStatus.None && loggedInAccount) {
      if (!(customerType && customerType === "patient")) {
        cacheAllWorkflowStates();
        cacheAllLookups();
        loadData();
      }
    }
  }, [inProgress, loggedInAccount]);

  return (
    <AuthContext>
      <div id="appSpire360" className="bg-white">
        <Header />
        <div className="aside__wrap">
          <Aside />
          <div className="flex-fill">
            <Outlet />
          </div>
        </div>
      </div>
      <Toaster
        show={show}
        onClose={() => dispatch(hideToast())}
        type={type}
        title={title}
        message={message}
        icon={icon}
      />
      <AppointmentOverlayBoundary>
        <AppointmentOverlay />
      </AppointmentOverlayBoundary>
    </AuthContext>
  );
};

export default ProtectedLayout;
